'use client';

import { FC, HTMLAttributes, ReactNode } from 'react';

import { PlanCardGridContainer, StyledPlanCardGrid } from './PlanCardGrid.styles';

type Props = {
    children: ReactNode;
    className?: string;
} & HTMLAttributes<HTMLDivElement>;

export const PlanCardGrid: FC<Props> = ({ children, ...inherited }) => {
    return (
        <PlanCardGridContainer>
            <StyledPlanCardGrid {...inherited}>{children}</StyledPlanCardGrid>
        </PlanCardGridContainer>
    );
};
